import { render, staticRenderFns } from "./OzCheckBox.vue?vue&type=template&id=52d1d576&"
import script from "./OzCheckBox.vue?vue&type=script&lang=ts&"
export * from "./OzCheckBox.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports